<template>
  <v-container fluid>
    <v-btn @click="$router.push({ name: 'applyLeave' })" class="applyLeave">
      Apply Leave
    </v-btn>
    <v-btn @click="$router.push({ name: 'leaveReport' })" class="leaveReport">
      Leave Report
    </v-btn>
    <v-btn @click="$router.push({ name: 'applyAttendance' })" class="applyAttendance">
      Apply Attendance
    </v-btn>
    <material-card icon="mdi-clipboard-text" inline title="My Attendance">
      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10"
          style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-component>
        <v-col>
          <v-sheet height="64">
            <v-toolbar flat>
              <v-btn fab text small color="grey darken-2" @click="prev">
                <v-icon small>
                  mdi-chevron-left
                </v-icon>
              </v-btn>
              <v-toolbar-title v-if="$refs.calendar">
                {{ $refs.calendar.title }}
              </v-toolbar-title>
              <v-btn fab text small color="grey darken-2" @click="next">
                <v-icon small>
                  mdi-chevron-right
                </v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-sheet>
          <div>
            <v-sheet height="600">

              <v-calendar :event-height='20' ref="calendar" v-model="focus" color="gray"
                :events="events" @click:more="moreEvent" @click:event="showEvent"
                :event-color="getEventColor" :type="type" @change="updateRange">
              </v-calendar>

              <v-menu v-model="selectedOpen" :close-on-content-click="false"
                :activator="selectedElement" offset-x>
                <v-card color="grey lighten-4" min-width="350px" flat>
                  <v-toolbar :color="selectedOpenMore ? 'blue' :selectedEvent.color" dark>
                    <!-- <v-btn icon>
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn> -->

                    <v-toolbar-title
                      v-html="selectedOpenMore ? currentSelectedDate : selectedEvent.name">
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <!-- <v-btn icon>
                    <v-icon>mdi-heart</v-icon>
                  </v-btn> -->
                    <!-- <v-btn icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn> -->
                    <v-btn icon @click="selectedOpen = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <div v-if="selectedOpenMore">
                    <v-list-item v-for="(item, index) in moreData" :key="index">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{item.name}}
                          <v-btn @click="deleteAttendanceRequest(item.id)" absolute right
                            v-if="item.id && item.status==='PENDING'" class="px-2 ml-1" style="margin: -6px"
                            color="error" min-width="0" small>
                            <v-icon small> mdi-delete</v-icon>
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </div>

                  <v-card-text v-if="!selectedOpenMore">
                    <span v-html="selectedEvent.details"></span>
                    <span>{{selectedEvent.label}}</span>
                    <v-btn @click="deleteAttendanceRequest(selectedEvent.id)" absolute right
                      v-if="selectedEvent.id && selectedEvent.status==='PENDING'" class="px-1 ml-1"
                      color="error" min-width="0" small>
                      <v-icon small> mdi-delete</v-icon> Delete request
                    </v-btn>
                    <br>
                    <span v-if="selectedEvent.leaveType">Leave Type:
                      {{selectedEvent.leaveType}}</span>
                  </v-card-text>
                  <!-- <v-card-actions>
                  <v-btn text color="secondary" @click="selectedOpen = false">
                    Close
                  </v-btn>
                </v-card-actions> -->
                </v-card>
              </v-menu>
            </v-sheet>
          </div>

        </v-col>

      </v-card-component>
    </material-card>
  </v-container>
</template>
<script>
import moment from 'moment'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import Utils from '@/utils'

export default {
  name: 'teacherAttendance',
  components: { VCardComponent, MaterialCard },
  data: () => ({
    focus: '',
    type: 'month',
    startDate: null,
    endDate: null,
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days'
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    selectedOpenMore: false,
    moreData: [],
    currentSelectedDate: null,
    moreNativeElement: null,
    events: [],
    colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1']
  }),
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      if (this.startDate && this.endDate) {
        this.events = []
        this.events = await this.weekEndEvents(this.startDate, this.endDate)
        this.getHolidays(this.startDate, this.endDate)
        this.$refs.calendar.checkChange()
      }
    },
    academicYear: async function (val) {
      if (this.startDate && this.endDate) {
        this.events = []
        this.events = await this.weekEndEvents(this.startDate, this.endDate)
        this.getHolidays(this.startDate, this.endDate)
        this.$refs.calendar.checkChange()
      }
    }
  },
  methods: {
    async getHolidays (start, end) {
      try {
        if (this.franchisee.id && this.academicYear.id) {
          const { data } = await http.get(`${constants.API_URL}/api/teacherAttendance/holidays`, {
            params: {
              startDate: moment(start).format('YYYY-MM-DD'),
              endDate: moment(end).format('YYYY-MM-DD'),
              franchiseeID: this.franchisee.id,
              academicYearID: this.academicYear.id
            }
          })
          console.log(
            data.teacherRequests.map((item) => {
              return item.type
            })
          )
          data.teacherRequests.forEach((item) => {
            let name = ''
            let color = ''
            switch (item.type) {
              case 'Leave':
                name = `Leave Request [${item.status}]`
                color = 'grey'
                if (item.status === 'APPROVED') {
                  color = '#228B22'
                } else if (item.status === 'REJECTED') {
                  color = '#B22222'
                }
                break
              case 'Attendance':
                name = `Attendance Request [${item.status}]`
                color = 'grey'
                if (item.status === 'APPROVED') {
                  name = 'Present'
                  color = '#D2691E'
                } else if (item.status === 'REJECTED') {
                  color = '#B22222'
                }
                break
            }
            // Adding individual event for same attendance request
            const currentMoment = moment(item.fromDate)
            const endMoment = moment(item.toDate)
            if (!currentMoment.isSame(endMoment)) {
              while (currentMoment.isBefore(endMoment, 'day') || currentMoment.isSame(endMoment)) {
                this.events.push({
                  id: item.id,
                  status: item.status,
                  leaveType: item.leaveDetails ? item.leaveDetails.name : null,
                  name: name,
                  start: new Date(currentMoment.format('YYYY-MM-DD')),
                  end: new Date(currentMoment.format('YYYY-MM-DD')),
                  color: color,
                  timed: false
                })
                currentMoment.add(1, 'days')
              }
            } else {
              this.events.push({
                id: item.id,
                status: item.status,
                leaveType: item.leaveDetails ? item.leaveDetails.name : null,
                name: name,
                start: new Date(item.fromDate),
                end: new Date(item.toDate),
                color: color,
                timed: false
              })
            }
          })
          data.attendanceHolidays.forEach((item) => {
            let name = ''
            let color = ''
            switch (item.type) {
              case 'Normal':
                name = `Holiday (${item.occasions})`
                color = '#228B22'
                break
              case 'Optional':
                name = `${item.occasions} (Optional)`
                color = 'orange'
                break
              case 'Weekend':
                name = item.occasions
                color = 'deep-purple'
                break
            }
            this.events.push({
              name: name,
              start: new Date(item.date),
              end: new Date(item.date),
              color: color,
              timed: false
            })
          })
          Utils.helper.openDrawer(this, false)
        } else {
          if (!this.franchisee.id) {
            Utils.helper.openDrawer(this)
          } else {
            Utils.helper.openDrawer(this, false)
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    weekEndEvents (start, end) {
      let events = []
      const currentMoment = moment(start)
      const endMoment = moment(end)
      while (currentMoment.isBefore(endMoment, 'day')) {
        // events.push({
        //   name: 'General Shift BB (09:00 AM - 06:00 PM)',
        //   start: new Date(currentMoment.format('YYYY-MM-DD')),
        //   end: new Date(currentMoment.format('YYYY-MM-DD')),
        //   color: 'grey',
        //   timed: false
        // })
        // Day : 0 = Sunday || Day : 6 = Saturday
        switch (moment(currentMoment).day()) {
          case 0:
            events.push({
              name: 'Weekly Off',
              start: new Date(currentMoment.format('YYYY-MM-DD')),
              end: new Date(currentMoment.format('YYYY-MM-DD')),
              color: 'deep-purple',
              timed: false
            })
            break
          case 6:
            events.push({
              name: 'Weekly Off',
              start: new Date(currentMoment.format('YYYY-MM-DD')),
              end: new Date(currentMoment.format('YYYY-MM-DD')),
              color: 'deep-purple',
              timed: false
            })
            break
        }
        currentMoment.add(1, 'days')
      }
      return events
    },
    async deleteAttendanceRequest (id) {
      try {
        this.$buefy.dialog.confirm({
          type: 'is-warning',
          title: 'Alert',
          hasIcon: true,
          message: 'Are you sure to delete this attendance request ?',
          onConfirm: async () => {
            const { data } = await http.put(`${constants.API_URL}/api/attendanceModule/declineattendanceleave/${id}`, {
              status: 'deleted'
            })
            console.log(data)
            this.selectedOpen = false
            this.events = []
            this.events = await this.weekEndEvents(this.startDate, this.endDate)
            this.getHolidays(this.startDate, this.endDate)
            this.$refs.calendar.checkChange()
          }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    updateRange ({ start, end }) {
      this.startDate = start.date
      this.endDate = end.date
      const events = this.weekEndEvents(start.date, end.date)
      this.events = events
      this.getHolidays(start.date, end.date)
    },
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor (event) {
      return event.color
    },
    setToday () {
      this.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    moreEvent ({ date }) {
      this.currentSelectedDate = moment(date).format('MMMM Do YYYY')
      this.moreData = this.events.filter((item) => {
        let start = moment(item.start).format('YYYY-MM-DD')
        let end = moment(item.end).format('YYYY-MM-DD')
        return moment(date).isSameOrAfter(start) && moment(date).isSameOrBefore(end)
      })
      this.selectedOpenMore = true
      this.selectedElement = this.moreNativeElement
      requestAnimationFrame(() => requestAnimationFrame(() => (this.selectedOpen = true)))
    },
    showEvent ({ nativeEvent, event }) {
      this.selectedOpenMore = false
      console.log(nativeEvent)
      const open = () => {
        this.selectedEvent = event
        console.log(this.selectedEvent)
        this.selectedEvent.label = moment(this.selectedEvent.start).format('MMMM Do YYYY')

        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => (this.selectedOpen = true)))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    }
  }
}
</script>
<style>
.applyAttendance {
  position: absolute;
  right: 142px;
  top: 58px;
  z-index: 1;
}

.applyLeave {
  position: absolute;
  right: 343px;
  top: 58px;
  z-index: 1;
}

.leaveReport {
  position: absolute;
  right: 495px;
  top: 58px;
  z-index: 1;
}

div .v-calendar .v-event,
.v-calendar .v-event-more {
  font-size: 9px;
  margin-left: 5px;
}
/* div .v-calendar .v-event div {
  display: contents;
} */
</style>
